module.exports = __webpack_public_path__ + "img/banner-04.a9e1995a.jpg";